/*
 * Copyright (c) 2024 Cozy Intellect Inc.
 */

import { derived } from 'svelte/store';
import { config as configStore } from './config';
import { devices } from './devices';

export const lastUsedDeviceStore = derived([devices, configStore], ([$devices, $config]) => {
  // Add defensive checks to prevent accessing uninitialized variables
  if (!$devices || !$config) {
    return null;
  }

  if ($config.lastUsedDevice) {
    const deviceName = $devices.deviceNameMap?.get($config.lastUsedDevice);
    if (deviceName) {
      return {
        deviceId: $config.lastUsedDevice,
        deviceName
      };
    }
  }
  return null;
});
